import { render } from "./InactiveOffice.vue?vue&type=template&id=099f03fb&scoped=true"
const script = {}

import "./InactiveOffice.vue?vue&type=style&index=0&id=099f03fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099f03fb"]])

export default __exports__